
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 0a6 6 0 014.688 9.745l2.45 2.45a.667.667 0 01-.88.998l-.063-.055-2.45-2.45A6 6 0 116 0zm0 1.333a4.667 4.667 0 103.255 8.01.256.256 0 01.04-.048l.044-.035A4.667 4.667 0 006 1.333z","fill":"#000"}})])
          )
        }
      }
    